import { useRaceChronoLapTiming } from "../hooks/useRaceChronoLapTiming";

function formatLapTime(ms: number | null) {
  if (ms === null) return "--:--.---";
  const minutes = Math.floor(ms / 60000);
  const seconds = Math.floor((ms % 60000) / 1000);
  const millis = ms % 1000;
  return `${minutes}:${String(seconds).padStart(2, "0")}.${String(millis).padStart(3, "0")}`;
}

function formatDelta(ms: number | null) {
  if (ms === null) return "—";
  return `${ms > 0 ? "+" : ""}${(ms / 1000).toFixed(3)}s`;
}

function formatState(state: string) {
  switch (state) {
    case "ready":
      return "Ready";
    case "configuring":
      return "Configuring";
    case "stale":
      return "Stale";
    case "error":
      return "Error";
    default:
      return "Disconnected";
  }
}

export function RaceChronoLapPanel({ topicPrefix }: { topicPrefix: string }) {
  const lap = useRaceChronoLapTiming(topicPrefix);

  return (
    <div className={`racechrono-live racechrono-live--${lap.state}`}>
      <div className="racechrono-live__summary">
        <div>
          <span className="racechrono-live__eyebrow">RaceChrono live</span>
          <strong>{formatState(lap.state)}</strong>
        </div>
        <div className="racechrono-live__chips">
          <span className="racechrono-live__chip">Lap {lap.lapNumber ?? "—"}</span>
          <span className="racechrono-live__chip">Current {formatLapTime(lap.currentLapTimeMs)}</span>
          <span className="racechrono-live__chip">Delta {formatDelta(lap.deltaLapTimeMs)}</span>
        </div>
      </div>

      <div className="racechrono-live__stats">
        <div>
          <span>Current lap</span>
          <strong>{formatLapTime(lap.currentLapTimeMs)}</strong>
        </div>
        <div>
          <span>Previous lap</span>
          <strong>{formatLapTime(lap.previousLapTimeMs)}</strong>
        </div>
        <div>
          <span>Best lap</span>
          <strong>{formatLapTime(lap.bestLapTimeMs)}</strong>
        </div>
        <div>
          <span>Delta</span>
          <strong>{formatDelta(lap.deltaLapTimeMs)}</strong>
        </div>
      </div>
    </div>
  );
}
